import { useQuery } from 'react-query';
import axiosInstance from './axiosInstance';
import { useAuthContext } from '../contexts/AuthContext';

const useFetch = (endpoint, id, params, enabled, method, baseUrl, body) => {
    const { checkToken } = useAuthContext();
    checkToken();

    const fetchData = async () => {
        const response = await axiosInstance(method, endpoint, params, 'application/json', baseUrl, body);
        return response;
    };

    return useQuery([id], () => fetchData(), {
        refetchOnWindowFocus: false,
        // refetchInterval: interval
        enabled: enabled === false ? false : true,
        retry: false,  // Desabilita tentativas automáticas em caso de erro
        onError: (error) => {
            console.error("Erro ao buscar dados:", error);  // Log do erro
        }
    });
};

export default useFetch;